import React, { useState } from 'react';
import { DrawerBody, DrawerFooter, Button, DrawerHeader, Typography, TileGroup, Link, Tile, TileMedia, } from '@one-thd/sui-atomic-components';
import { RadioButtonUnchecked, ConfirmedFilled } from '@one-thd/sui-icons';
export var PaymentPermissionsDrawer = function (_a) {
    var PTCs = _a.PTCs, preselectedPaymentIDs = _a.preselectedPaymentIDs, hideDrawer = _a.hideDrawer, onApply = _a.onApply;
    var _b = useState(function () { return preselectedPaymentIDs; }), selectedPaymentIDs = _b[0], setSelectedPaymentIDs = _b[1];
    var totalPermissions = PTCs.length;
    var shopLinesOfCredit = PTCs.filter(function (PTC) { return PTC.locType === 'SHOP'; });
    var projectLinesOfCredit = PTCs.filter(function (PTC) { return PTC.locType === 'PROJECT'; });
    var totalPaymentsIDs = PTCs.map(function (PTC) { return PTC.paymentId.toString(); });
    var titleText = "Pro Trade Credit (".concat(totalPermissions, ")");
    var bodyText = 'You may grant permission to Admins and Purchasers on your account to use these lines of credit when checking out online. The balance of these lines of credit will be available to all users you grant permission to.';
    var handleTileChange = function (_event, newFormats) {
        setSelectedPaymentIDs(newFormats);
    };
    var handleSelectAll = function () {
        if (totalPermissions === selectedPaymentIDs.length) {
            setSelectedPaymentIDs([]);
        }
        else {
            setSelectedPaymentIDs(totalPaymentsIDs);
        }
    };
    var getSelectAllText = function () {
        if (totalPermissions === selectedPaymentIDs.length) {
            return "Deselect All (".concat(selectedPaymentIDs.length, " selected)");
        }
        if (selectedPaymentIDs.length > 0) {
            return "Select All (".concat(selectedPaymentIDs.length, " selected)");
        }
        return 'Select All';
    };
    return (React.createElement("div", null,
        React.createElement(DrawerHeader, { title: titleText, onClose: hideDrawer }),
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-mb-4" },
                React.createElement(Typography, { variant: "body-xs" }, bodyText)),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement("div", null,
                    React.createElement(Link, { component: "button", onClick: handleSelectAll, "data-testid": "select-button" }, getSelectAllText())),
                React.createElement(TileGroup, { className: "sui-w-full sui-flex sui-flex-col sui-gap-2", grow: true, value: selectedPaymentIDs, onChange: handleTileChange, "aria-label": "shipping options", disableExclusive: true, "data-testid": "payment-permissions-tile-group" },
                    React.createElement(Typography, { weight: "bold", height: "tight" }, "Shop Line"),
                    shopLinesOfCredit.map(function (PTC) { return (React.createElement(Tile, { key: PTC.paymentId.toString(), value: PTC.paymentId.toString(), "aria-label": PTC.locName },
                        React.createElement("div", { className: "sui-w-full sui-flex sui-justify-between" },
                            React.createElement(Typography, null, PTC.locName),
                            React.createElement(TileMedia, null,
                                ' ',
                                selectedPaymentIDs.includes(PTC.paymentId.toString()) ? (React.createElement(ConfirmedFilled, { size: "small", color: "primary", "data-testid": "confirmed-checkbox" })) : (React.createElement(RadioButtonUnchecked, { size: "small", "data-testid": "radio-button-unchecked" })))))); }),
                    React.createElement("div", { className: "sui-mt-4" },
                        React.createElement(Typography, { weight: "bold", height: "tight" }, "Project Lines")),
                    projectLinesOfCredit.map(function (PTC) { return (React.createElement(Tile, { key: PTC.paymentId.toString(), value: PTC.paymentId.toString(), "aria-label": PTC.locName },
                        React.createElement("div", { className: "sui-w-full sui-flex sui-justify-between" },
                            React.createElement(Typography, null, PTC.locName),
                            React.createElement(TileMedia, null,
                                ' ',
                                selectedPaymentIDs.includes(PTC.paymentId.toString()) ? (React.createElement(ConfirmedFilled, { size: "small", color: "primary", "data-testid": "confirmed-checkbox" })) : (React.createElement(RadioButtonUnchecked, { size: "small", "data-testid": "radio-button-unchecked" })))))); })))),
        React.createElement(DrawerFooter, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-2" },
                React.createElement(Button, { fullWidth: true, onClick: function () {
                        onApply(selectedPaymentIDs);
                        hideDrawer();
                    }, "data-testid": "drawer-apply-button" }, "Apply"),
                React.createElement(Button, { fullWidth: true, variant: "secondary", onClick: hideDrawer, "data-testid": "drawer-cancel-button" }, "Cancel")))));
};
